import React, {useEffect,  useState} from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "../../base-components/base-paragraph";
import StepsLoader from "../steps-loader";
import StepFooterAction from "../../base-components/step-footer-action";
import IdInputField from '../../idInput/idInput';

const IDStep = ({ _step_service, _media_service, error, step_ID, step_URL, next_step, setDataToContext, getDataFromContext, step_form}) => {
    const lang = localStorage.getItem('language')
    const data = getDataFromContext(step_ID)
    const [inputData, setInputData] = useState({ ...data })
    const [isValid, setIsValid] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const idFieldConfig = [
        {
            id: "front",
            label: t('financial_infos.financial_info_id_verification.recto_label'),
            contentTitle: t('financial_infos.financial_info_id_verification.add_id'),
            contentbody: t('error_messages.image_type_limit'),
            dataFile: inputData.front,
            nameLabel:t('financial_infos.financial_info_id_verification.recto')
        },
        {
            id: "back",
            label: t('financial_infos.financial_info_id_verification.verso_label'),
            contentTitle: t('financial_infos.financial_info_id_verification.add_id'),
            contentbody: t('error_messages.image_type_limit'),
            dataFile: inputData.back,
            nameLabel:t('financial_infos.financial_info_id_verification.verso')

        }
    ]

    const getInputValue = (name, value) => {
        console.log('here sending the id card')
            setInputData({
            ...inputData,
            [name] : value
        })
        setDataToContext(step_ID, step_URL, name, value)
        value && _media_service({ id: name, setIsLoading, value })
        
               if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                    pageID: "onboarding",
                    stepSeq: "2",
                    stepName: name === 'front' ? "financial info:id verification front" : "financial info:id verification back",
                    flowType: "sales",
                    flowName: "onboarding",
                    productName: "onboarding",
                    trackMethod: "flow"
                    }
                );
            }
        
    }

    useEffect(() => {
        setIsValid(inputData.front && inputData.back)
    }, [inputData])

        React.useEffect(() => {
            if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                    pageID: "onboarding",
                    stepSeq: "2",
                    stepName: "financial info:id verification",
                    flowType: "sales",
                    flowName: "onboarding",
                    productName: "onboarding",
                    trackMethod: "flow"
                    }
                );
            }

     }, [])

    return (
        <>
        <StepsLoader loading={isLoading}>
            <form>
                <BaseParagraph>
                    <h3>{t('financial_infos.financial_info_id_verification.title')}</h3>
                    <p>{ t('financial_infos.financial_info_id_verification.text')}</p>
                </BaseParagraph>           
                {idFieldConfig.map(input => <IdInputField
                    dataFile={input.dataFile}
                    step_ID={step_ID}
                    step_URL={step_URL}
                    setDataToContext={setDataToContext}
                    getInputValue={getInputValue}
                    key= {input.id}
                    type={"idInput"}
                    name={input.id}
                    nameLabel={input.nameLabel}
                    content={{
                        label : input.label,
                        contentTitle: input.contentTitle,
                        contentbody: input.contentbody
                    }}
                />
                )}
            </form>
            <StepFooterAction caption={t('general.continue')} link={`/${lang.toLowerCase()}/pro-info/`} disabled={!isValid} />
        </StepsLoader>
        </>
    )
}

IDStep.propTypes = {
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
    error: PropTypes.array,
    _step_service: PropTypes.func,
}

IDStep.defaultProps = {
    name: "email-step"
}


export default IDStep